import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Music2, Apple } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0A0A] border-t border-white/5 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/5">
          <div className="md:col-span-6">
            <a href="#top" className="flex items-baseline gap-2">
              <span className="font-display text-3xl md:text-4xl text-white">
                Daniel
              </span>
              <span className="font-display italic text-3xl md:text-4xl text-[#D4AF37]">
                Lopes
              </span>
            </a>
            <p className="mt-6 max-w-md text-[#A3A3A3] font-body text-sm leading-relaxed">
              Premium Schlager · Festival Headliner · TV-erprobt. Für
              Buchungsanfragen wenden Sie sich direkt an das Management.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Direktkontakt</p>
            <ul className="space-y-2 text-[#C9C9C9] font-body text-sm">
              <li>
                <a
                  href="mailto:booking@daniellopes.net"
                  className="hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-email"
                >
                  booking@daniellopes.net
                </a>
              </li>
              <li>Daniel Lopes Music UG</li>
              <li>Tivolistraße 75, 52349 Düren</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Folgen</p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/officialdaniellopes?igsh=MTE3MTVoZTJlaGtvaA%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-[#C9C9C9] flex items-center justify-center transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                href="https://youtube.com/@daniellopesofficial?si=uqxnLH6SQcuyW2FA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-10 h-10 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-[#C9C9C9] flex items-center justify-center transition-colors"
                data-testid="footer-youtube"
              >
                <Youtube size={16} strokeWidth={1.5} />
              </a>
              <a
                href="https://open.spotify.com/artist/2KSTe6bHvOVnotewpdelFI?si=ZawMDcGhS5uCguDCCkpTcA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Spotify"
                className="w-10 h-10 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-[#C9C9C9] flex items-center justify-center transition-colors"
                data-testid="footer-spotify"
              >
                <Music2 size={16} strokeWidth={1.5} />
              </a>
              <a
                href="https://music.apple.com/de/artist/daniel-lopes/40701009"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Apple Music"
                className="w-10 h-10 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-[#C9C9C9] flex items-center justify-center transition-colors"
                data-testid="footer-apple-music"
              >
                <Apple size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-8 text-xs text-[#7A7A7A]">
          <p>
            © {new Date().getFullYear()} Daniel Lopes. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-[#D4AF37]" data-testid="footer-imprint">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-[#D4AF37]" data-testid="footer-privacy">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
